/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(38)('wks')
  , uid        = __webpack_require__(23)
  , Symbol     = __webpack_require__(3).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(0)
  , ctx       = __webpack_require__(28)
  , hide      = __webpack_require__(13)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(11)
  , IE8_DOM_DEFINE = __webpack_require__(47)
  , toPrimitive    = __webpack_require__(40)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(48)
  , defined = __webpack_require__(29);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(43);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(4)
  , createDesc = __webpack_require__(19);
module.exports = __webpack_require__(6) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(52)
  , enumBugKeys = __webpack_require__(30);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(74);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(72);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(45);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(45);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(29);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(44);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(79);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var DataObject = function () {
    function DataObject() {
        var requiredFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var acceptedFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var _this = this;

        var initialFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, DataObject);

        this.name = this.constructor.name;
        this.requiredFields = [].concat((0, _toConsumableArray3.default)(requiredFields));
        this.acceptedFields = [].concat((0, _toConsumableArray3.default)(acceptedFields));
        this.allFields = [].concat((0, _toConsumableArray3.default)(requiredFields), (0, _toConsumableArray3.default)(acceptedFields));

        (0, _keys2.default)(initialFields).forEach(function (key) {
            var isValidKey = _this.isValidField(key);
            if (keepExtraFields || isValidKey) {
                _this[key] = typeof initialFields[key] !== 'undefined' && initialFields[key] !== null ? initialFields[key].toString() : '';

                if (!isValidKey) {
                    _this.allFields.push(key);
                }
            }
        });
    }

    (0, _createClass3.default)(DataObject, [{
        key: 'isValidField',
        value: function isValidField(key) {
            return !!this.constructor[key.toUpperCase()];
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            var _this2 = this;

            var additionalRequiredFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var fieldsToCheck = [].concat((0, _toConsumableArray3.default)(this.requiredFields), (0, _toConsumableArray3.default)(additionalRequiredFields));

            fieldsToCheck.forEach(function (field) {
                // You can have empty string as value
                if (!(_this2.hasOwnProperty(field) || map[field] && map[field].hasOwnProperty('defaultValue'))) {
                    throw new Error(_this2.constructor.name + ' object must have \'' + field + '\' defined');
                }
            });
        }
    }, {
        key: 'build',
        value: function build() {
            var _this3 = this;

            var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var constructedObj = {};
            this.allFields.forEach(function (field) {
                var fieldKey = field;
                if (map[field] && map[field].name) {
                    fieldKey = map[field].name;
                }

                if (_this3.hasOwnProperty(field)) {
                    constructedObj[fieldKey] = _this3[field].toString();
                } else if (map[field] && map[field].hasOwnProperty('defaultValue')) {
                    constructedObj[fieldKey] = map[field].defaultValue;
                }
            });
            return constructedObj;
        }
    }, {
        key: 'sanitizeMoney',
        value: function sanitizeMoney(field) {
            if (this[field]) {
                var value = this[field].match(/[\d,'./]/g);
                if (value) {
                    value = value.join('').replace(/[,'.]$/, ''); // leave only valid monetary syntaxes and strip trailing syntaxs
                    var match = value.match(/(.*?)(([,'./])(\d{1,2}))?$/); // break money string (ie: '10,000' , '.', '99')
                    /* istanbul ignore else */
                    if (match) {
                        var sanitizedValue = match[1].match(/\d/g); // digits only for first match (ie. '10000')
                        if (sanitizedValue) {
                            this[field] = sanitizedValue.join('');

                            if (match[3] && match[4]) {
                                this[field] += '.' + match[4]; // convert float seprator to period
                            }
                            return;
                        }
                    }
                }

                this[field] = '';
            }
        }
    }]);
    return DataObject;
}();

exports.default = DataObject;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

/**
 * Logger
 *
 * Simple module to enable logging under debug conditions only. Defaults to
 * determining debug status based on preview, which is shared across all instances
 *
 * Usage:
 *     const logger = new Logger('myPrefix')
 *
 * @param {string} [prefix] - Appends the given prefix to any logging statements - defaults to empty string
 * @returns {Logger}
 */
var Logger = function Logger(prefix) {
  this.prefix = prefix || '';
  return this;
};

Logger._debugFlag = !!(window.Mobify && typeof window.Mobify.Preview !== 'undefined');

/**
 * Toggles the debug setting on and off
 *
 * @param {boolean} isDebug - `true` to toggle on, `false` to toggle off
 */
Logger.setDebug = function (isDebug) {
  Logger._debugFlag = !!isDebug;
};

/**
 * Logs to console only if debug setting is true.
 *
 * @param {*} args - Comma separated arguments to log to console
 * @returns undefined
 */
Logger.prototype.log = function () {
  var _console;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  Logger._debugFlag && (_console = console).log.apply(_console, [this.prefix].concat(args));
};

/**
 * Logs to console regardless of debug setting.
 *
 * @param {*} args - Comma separated arguments to log to console
 * @returns undefined
 */
Logger.prototype.forceLog = function () {
  var _console2;

  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  (_console2 = console).log.apply(_console2, [this.prefix].concat(args));
};

exports.default = Logger;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UIInteraction = exports.ShoppingList = exports.Transaction = exports.Product = exports.Page = exports.UI_NAME = exports.UI_OBJECT = exports.UI_ACTION = exports.UI_SUBJECT = exports.PERFORMANCE_METRICS = exports.EVENT_ACTION = undefined;

var _page = __webpack_require__(128);

var _page2 = _interopRequireDefault(_page);

var _product = __webpack_require__(56);

var _product2 = _interopRequireDefault(_product);

var _transaction = __webpack_require__(130);

var _transaction2 = _interopRequireDefault(_transaction);

var _shoppingList = __webpack_require__(129);

var _shoppingList2 = _interopRequireDefault(_shoppingList);

var _uiInteraction = __webpack_require__(131);

var _uiInteraction2 = _interopRequireDefault(_uiInteraction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Data Action Schema
var EVENT_ACTION = exports.EVENT_ACTION = {
    pageview: 'pageview',
    purchase: 'purchase',
    addToCart: 'addToCart',
    productDetail: 'productDetail',
    productImpression: 'productImpression',
    removeFromCart: 'removeFromCart',
    addToWishlist: 'addToWishlist',
    removeFromWishlist: 'removeFromWishlist',
    search: 'search',
    uiInteraction: 'uiInteraction',
    launchedFromHomeScreen: 'launchedFromHomeScreen',
    setCurrency: 'setCurrency',
    performance: 'performance',
    applePayOptionDisplayed: 'applePayOptionDisplayed',
    applePayButtonDisplayed: 'applePayButtonDisplayed',
    applePayButtonClicked: 'applePayButtonClicked',
    offlineModeUsed: 'offlineModeUsed'
}; /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var PERFORMANCE_METRICS = exports.PERFORMANCE_METRICS = {
    pageStart: 'pageStart',
    mobifyStart: 'mobifyStart',
    firstPaint: 'firstPaint',
    firstContentfulPaint: 'firstContentfulPaint',
    appStart: 'appStart',
    templateWillMount: 'templateWillMount',
    templateDidMount: 'templateDidMount',
    templateAPIEnd: 'templateAPIEnd',
    fullPageLoad: 'fullPageLoad',
    timeToInteractive: 'timeToInteractive',
    inputLatency: 'inputLatency',
    isSavedPage: 'isSavedPage'
};

// Interaction Schema
var UI_SUBJECT = exports.UI_SUBJECT = {
    app: 'app',
    user: 'user'
};

var UI_ACTION = exports.UI_ACTION = {
    click: 'Click',
    focus: 'Focus',
    blur: 'Blur',
    open: 'Open',
    close: 'Close',
    display: 'Display',
    receive: 'Receive',
    swipe: 'Swipe'
};

var UI_OBJECT = exports.UI_OBJECT = {
    button: 'Button',
    element: 'Element',
    error: 'Error',
    input: 'Input',
    modal: 'Modal'
};

var UI_NAME = exports.UI_NAME = {
    accept: 'accept',
    accordion: 'accordion',
    additionalAddressInfo: 'additional_address_info',
    address: 'address',
    addressName: 'address_name',
    addNewAddress: 'add_new_address',
    addNewCard: 'add_new_card',
    addPromotionCode: 'add_promotion_code',
    addToCart: 'add_to_cart',
    addToHome: 'add_to_home',
    askQuestions: 'ask_questions',
    autoReplenish: 'auto_replenish',
    autoReplenishFrequency: 'auto_replenish_frequency',
    all: 'all',
    applePay: 'apple_pay',
    applePayPaymentMethod: 'apple_pay_payment_method',
    bottom: 'bottom',
    billingAddress: 'billing_address',
    browserForward: 'browser_forward',
    browserRefresh: 'browser_refresh',
    cancel: 'cancel',
    cancelAutoReplenish: 'cancel_auto_replenish',
    cancelRemoveItem: 'cancel_remove_item',
    calculateTax: 'calculate_tax',
    cardExpiryDate: 'card_expiry_date',
    cardHolderName: 'card_holder_name',
    cardNumber: 'card_number',
    cardVerification: 'card_verification',
    carousel: 'carousel',
    clearFilters: 'clear_filters',
    clearSearch: 'clear_search',
    checkBalance: 'check_balance',
    checkout: 'checkout',
    contactUs: 'contact_us',
    chooseFile: 'choose_file',
    city: 'city',
    collapse: 'collapse',
    consensus: 'consensus',
    copy: 'copy',
    count: 'count',
    country: 'country',
    company: 'company',
    confirmation: 'confirmation',
    confirmEmail: 'confirm_email',
    confirmPassword: 'confirm_password',
    confirmRemoveItem: 'confirm_remove_item',
    continueCheckout: 'continue_checkout',
    continueOffline: 'continue_offline',
    continueShopping: 'continue_shopping',
    createAccountConfirmation: 'create_account_confirmation',
    currentPassword: 'current_password',
    custom: 'custom',
    customerName: 'customer_name',
    dateOfBirth: 'date_of_birth',
    decrementQuantity: 'decrement_quantity',
    dismiss: 'dismiss',
    dismissModal: 'dismiss_modal',
    dismissNotification: 'dismiss_notification',
    dismissSearch: 'dismiss_search',
    donate: 'donate',
    editBag: 'edit_bag',
    editItem: 'edit_item',
    editSavedAddress: 'edit_saved_address',
    email: 'email',
    enablePushNotification: 'enable_push_notification',
    enableLocationService: 'enable_location_service',
    expand: 'expand',
    estimateShipping: 'estimate_shipping',
    facebook: 'facebook',
    feedback: 'feedback',
    filters: 'filters',
    firstName: 'first_name',
    gender: 'gender',
    gift: 'gift',
    giftCertificate: 'gift_certificate',
    giftCertificateAmount: 'gift_certificate_amount',
    giftCertificatePin: 'gift_certificate_pin',
    goToCart: 'go_to_cart',
    goToRegister: 'go_to_register',
    goToSignIn: 'go_to_sign_in',
    incrementQuantity: 'increment_quantity',
    info: 'info',
    inputValidation: 'input_validation',
    lastName: 'last_name',
    launch: 'launch',
    login: 'login',
    logout: 'logout',
    menu: 'menu',
    message: 'message',
    miniCart: 'mini_cart',
    moreMenu: 'more_menu',
    moreSwatches: 'more_swatches',
    navigateBack: 'navigate_back',
    next: 'next',
    offline: 'offline',
    page: 'page',
    pagination: 'pagination',
    password: 'password',
    payment: 'payment',
    paymentMethod: 'payment_method',
    phone: 'phone',
    postcode: 'zip_postal_code',
    previous: 'previous',
    print: 'print',
    promotionCode: 'promotion_code',
    prompt: 'prompt',
    recalculateTax: 'recalculate_tax',
    recipientEmail: 'recipient_email',
    recipientName: 'recipient_name',
    region: 'state_province_region',
    register: 'register',
    remember: 'remember',
    removeDiscount: 'remove_discount',
    removeItem: 'remove_item',
    removePromotionCode: 'remove_promotion_code',
    removeSavedAddress: 'remove_saved_address',
    reorder: 'reorder',
    rewards: 'rewards',
    retryConnection: 'retry_connection',
    salutation: 'salutation',
    savedAddress: 'saved_address',
    savedCard: 'saved_card',
    saveItem: 'save_item',
    sameAsShipping: 'same_as_shipping',
    sample: 'sample',
    search: 'search',
    setDefault: 'set_default',
    shareCopy: 'share_copy',
    shareEmail: 'share_email',
    shareModal: 'share_modal',
    sharePrint: 'share_print',
    shareFacebook: 'share_facebook',
    shareTwitter: 'share_twitter',
    shippingAddress: 'shipping_address',
    shippingMethod: 'shipping_method',
    sortBy: 'sort_by',
    showFilters: 'show_filters',
    showMenu: 'show_menu',
    showMiniCart: 'show_mini_cart',
    showMoreAddressFields: 'show_more_address_fields',
    showPromotionCode: 'show_promotion_code',
    showSearchBar: 'show_search_bar',
    showStoreLocator: 'show_store_locator',
    snapchat: 'snapchat',
    socialLogin: 'social_login',
    stockNotification: 'stock_notification',
    storeSearch: 'store_search',
    swatch: 'swatch',
    submitOrder: 'submit_order',
    submitPromoCode: 'submit_promo_code',
    subscribe: 'subscribe',
    top: 'top',
    twitter: 'twitter',
    togglePasswordText: 'toggle_password_text',
    upload: 'upload',
    validateAddress: 'validate_address',
    view: 'view',
    viewAllStores: 'view_all_stores',
    wishlist: 'wishlist',
    zoom: 'zoom'
};

exports.Page = _page2.default;
exports.Product = _product2.default;
exports.Transaction = _transaction2.default;
exports.ShoppingList = _shoppingList2.default;
exports.UIInteraction = _uiInteraction2.default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(71);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(91);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(11)
  , dPs         = __webpack_require__(107)
  , enumBugKeys = __webpack_require__(30)
  , IE_PROTO    = __webpack_require__(37)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(46)('iframe')
    , i      = enumBugKeys.length
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(97).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write('<script>document.F=Object</script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(22)
  , createDesc     = __webpack_require__(19)
  , toIObject      = __webpack_require__(5)
  , toPrimitive    = __webpack_require__(40)
  , has            = __webpack_require__(7)
  , IE8_DOM_DEFINE = __webpack_require__(47)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2)
  , core    = __webpack_require__(0)
  , fails   = __webpack_require__(12);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(4).f
  , has = __webpack_require__(7)
  , TAG = __webpack_require__(1)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(38)('keys')
  , uid    = __webpack_require__(23);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(3)
  , core           = __webpack_require__(0)
  , LIBRARY        = __webpack_require__(31)
  , wksExt         = __webpack_require__(42)
  , defineProperty = __webpack_require__(4).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(1);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(76);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(75);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(6) && !__webpack_require__(12)(function(){
  return Object.defineProperty(__webpack_require__(46)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(27);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(31)
  , $export        = __webpack_require__(2)
  , redefine       = __webpack_require__(53)
  , hide           = __webpack_require__(13)
  , has            = __webpack_require__(7)
  , Iterators      = __webpack_require__(18)
  , $iterCreate    = __webpack_require__(101)
  , setToStringTag = __webpack_require__(36)
  , getPrototypeOf = __webpack_require__(51)
  , ITERATOR       = __webpack_require__(1)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(52)
  , hiddenKeys = __webpack_require__(30).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(7)
  , toObject    = __webpack_require__(20)
  , IE_PROTO    = __webpack_require__(37)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(7)
  , toIObject    = __webpack_require__(5)
  , arrayIndexOf = __webpack_require__(93)(false)
  , IE_PROTO     = __webpack_require__(37)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(39)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(110)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(49)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = __webpack_require__(21);

var _dataObject2 = _interopRequireDefault(_dataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Product = function (_DataObject) {
    (0, _inherits3.default)(Product, _DataObject);
    (0, _createClass3.default)(Product, null, [{
        key: 'ID',
        get: function get() {
            return 'id';
        }
    }, {
        key: 'NAME',
        get: function get() {
            return 'name';
        }
    }, {
        key: 'CATEGORY',
        get: function get() {
            return 'category';
        }
    }, {
        key: 'BRAND',
        get: function get() {
            return 'brand';
        }
    }, {
        key: 'VARIANT',
        get: function get() {
            return 'variant';
        }
    }, {
        key: 'LIST',
        get: function get() {
            return 'list';
        }
    }, {
        key: 'POSITION',
        get: function get() {
            return 'position';
        }
    }, {
        key: 'PRICE',
        get: function get() {
            return 'price';
        }
    }, {
        key: 'QUANTITY',
        get: function get() {
            return 'quantity';
        }
    }, {
        key: 'COUPON',
        get: function get() {
            return 'coupon';
        }
    }, {
        key: 'STOCK',
        get: function get() {
            return 'stock';
        }
    }, {
        key: 'SIZE',
        get: function get() {
            return 'size';
        }
    }, {
        key: 'COLOR',
        get: function get() {
            return 'color';
        }
    }]);

    function Product(fields, additionalRequiredFields, keyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, Product);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).call(this, [Product.ID, Product.NAME], [Product.CATEGORY, Product.BRAND, Product.VARIANT, Product.LIST, Product.POSITION, Product.PRICE, Product.QUANTITY, Product.COUPON, Product.STOCK, Product.SIZE, Product.COLOR], fields, keepExtraFields));

        _this.sanitizeMoney(Product.PRICE);

        _this.isValid(additionalRequiredFields, keyMap);

        return _ret = _this.build(keyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return Product;
}(_dataObject2.default); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = Product;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var PAGE_COUNT = exports.PAGE_COUNT = 'pageCount';
var VISIT_COUNTDOWNS = exports.VISIT_COUNTDOWNS = 'visitCountdowns';
var VISITS_TO_WAIT = exports.VISITS_TO_WAIT = 'visitsToWait';
var CHANNEL_NAME = exports.CHANNEL_NAME = 'channelName';
var DEFAULT_CHANNEL = exports.DEFAULT_CHANNEL = 'broadcast';

var ACTIVE_VISIT_DURATION = exports.ACTIVE_VISIT_DURATION = 6 * 60 * 60; // 6 hours in seconds
var PERMA_DURATION = exports.PERMA_DURATION = 365 * 24 * 60 * 60; // 1 year in seconds

var MESSAGING_STATUS = exports.MESSAGING_STATUS = {
    LOADING: 0,
    READY: 1,
    FAILED: -1
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateState = exports.setPageCount = exports.getPageCount = exports.decreaseVisitCountdowns = exports.startVisitCountdown = exports.getVisitCountdowns = exports.setVisitCountdownsInStorage = exports.initStorage = undefined;

var _constants = __webpack_require__(57);

var _logger = __webpack_require__(24);

var _logger2 = _interopRequireDefault(_logger);

var _pushMessagingStore = __webpack_require__(135);

var _pushMessagingStore2 = _interopRequireDefault(_pushMessagingStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storage = void 0; /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var logger = void 0;

/**
 * Creates local instances of PushMessaginStore and Logger, for use in other
 * methods. Call this first before any other methods.
 */
var initStorage = exports.initStorage = function initStorage() {
    storage = storage || new _pushMessagingStore2.default('pw');
    logger = logger || new _logger2.default('[Messaging UI]');

    return storage;
};
/**
 * Sets the provided countdowns object in local storage.
 *
 * @param {object} countdowns - The visit countdowns object to set in storage
 * @returns {object} the provided `countdowns` argument
 */
var setVisitCountdownsInStorage = exports.setVisitCountdownsInStorage = function setVisitCountdownsInStorage(countdowns) {
    storage.set(_constants.VISIT_COUNTDOWNS, countdowns, _constants.PERMA_DURATION);

    return countdowns;
};

/**
 * Gets the visit countdowns object from local storage
 *
 * @returns {object} current visit countdowns
 */
var getVisitCountdowns = exports.getVisitCountdowns = function getVisitCountdowns() {
    return storage.get(_constants.VISIT_COUNTDOWNS) || {};
};

/**
 * Adds the optionally provided channel name, or "default" to the visit countdowns
 * object, with the provided `visitsToWait` argument, which is then set in local
 * storage.
 *
 * @param {number} visitsToWait - The number of visits to wait before showing an ask again
 * @param {string} [channelName] - Optional channel name (default is 'broadcast')
 * @returns {object} current visit countdowns
 */
var startVisitCountdown = exports.startVisitCountdown = function startVisitCountdown(visitsToWait) {
    var channelName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_CHANNEL;

    var countdowns = getVisitCountdowns();
    countdowns[channelName] = visitsToWait;

    return setVisitCountdownsInStorage(countdowns);
};

/**
 * Retrieves visit countdowns from local storage, decreases each key's value by 1,
 * then sets the value in local storage again.
 *
 * @returns {object} - current visit countdowns
 */
var decreaseVisitCountdowns = exports.decreaseVisitCountdowns = function decreaseVisitCountdowns() {
    var countdowns = getVisitCountdowns();

    for (var counter in countdowns) {
        /* istanbul ignore else */
        if (countdowns.hasOwnProperty(counter)) {
            countdowns[counter] = Math.max(0, countdowns[counter] - 1);
        }
    }

    return setVisitCountdownsInStorage(countdowns);
};

/**
 * Gets the current page count from local storage.
 *
 * @returns {number} The current page count, or 0 if not found in storage
 */
var getPageCount = exports.getPageCount = function getPageCount() {
    return storage.get(_constants.PAGE_COUNT) || 0;
};

/**
 * Sets the page count in storage using the provided pageCount argument
 *
 * @param {number} pageCount - the page count to set in storage
 * @returns {number} the provided `pageCount` argument
 */
var setPageCount = exports.setPageCount = function setPageCount(pageCount) {
    return storage.set(_constants.PAGE_COUNT, pageCount, _constants.ACTIVE_VISIT_DURATION);
};

/**
 * Updates and retrieves the current page count and visit countdowns from local
 * storage, decreasing visit countdowns if page count was not found.
 *
 * @returns {object}
 *   - pageCount: the current page count
 *   - visitCountdowns: the current visit countdowns
 */
var updateState = exports.updateState = function updateState() {
    var pageCount = getPageCount();
    var countdowns = void 0;

    // If pageCount is 0, it means it wasn't found in storage - this indicates
    // it expired and we should decrement visit countdowns
    if (pageCount === 0) {
        logger.log('Visit elapsed, decreasing visit countdowns.');
        countdowns = decreaseVisitCountdowns();
    } else {
        countdowns = getVisitCountdowns();
    }

    setPageCount(++pageCount);

    return {
        pageCount: pageCount,
        visitCountdowns: countdowns
    };
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : global)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global,
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(key, val) {
		fn(key, val)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(141)))

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendCartEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendPurchaseEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___);



var sendCartEvent = function sendCartEvent(cartAction) {
    var updatedCartQty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    setTimeout(function () {
        // Expecting the sandy object to be initialized already by loader.js
        if (!window.sandy) {
            console.error('Sandy is not available');
            return;
        }

        window.sandy('set', 'cart_items', updatedCartQty);
        window.sandy('send', 'event', 'timing', cartAction);

        // NOTE
        // Looking at past implementations, the bare minimum data to send is only `cart_items`:
        // https://github.com/mobify/lancome-analytics/blob/master/config/config.js
        // https://github.com/mobify/analytics-sdk/blob/78bd78b58eac0c10bb91993f26195916ccbeef82/src/integrations/sandy.js#L45
    });
};

// Mimicking the Engagement Engine connector:
// https://github.com/mobify/progressive-web-sdk/blob/19cbfc1721a12ee83d049724058b311e0b55a853/src/analytics/connectors/engagement-engine/connector.js#L294
var sendPurchaseEvent = function sendPurchaseEvent(purchase) {
    setTimeout(function () {
        // Expecting the sandy object to be initialized already by loader.js
        if (!window.sandy) {
            console.error('Sandy is not available');
            return;
        }

        var purchaseInfo = new __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Transaction"](purchase.transaction, purchase.products, [__WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Transaction"].REVENUE], [__WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Product"].PRICE, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Product"].QUANTITY], {
            id: {
                name: 'transaction_id'
            }
        }, {
            id: {
                name: 'product_id'
            }
        }, false);

        purchaseInfo.products.forEach(function (product) {
            window.sandy('send', 'event', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                eventCategory: 'ecommerce',
                eventAction: __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["EVENT_ACTION"].purchase + '.product',
                // product dimensions below
                transaction_id: purchaseInfo.transaction.transaction_id
            }, product));
        });

        window.sandy('send', 'event', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            eventCategory: 'ecommerce',
            eventAction: __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["EVENT_ACTION"].purchase
        }, purchaseInfo.transaction));
    });
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cart = {
    isActivePage: function isActivePage() {
        return (/cart\.carparts\.com/.test(window.location.hostname) && /\/basket\/?$/.test(window.location.pathname)
        );
    },
    hasDeletedItem: function hasDeletedItem() {
        return (/(\?|&)deleteitem=/.test(window.location.search)
        );
    },
    hasAddedItem: function hasAddedItem() {
        return (/(\?|&)ai=true/.test(window.location.search)
        );
    }
};

/* harmony default export */ __webpack_exports__["a"] = (cart);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___);



var extractPrice = function extractPrice() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var index = string.indexOf('$');
    var dollarValue = string.slice(index !== -1 ? index : 0);

    return parseFloat(dollarValue.replace('$', ''));
};

var extractQty = function extractQty(string) {
    return string.match(/\d+/)[0];
};

var checkoutConfirmation = {
    isActivePage: function isActivePage() {
        return (/\/checkout\/confirmation/.test(window.location.pathname)
        );
    },

    getPurchaseDetails: function getPurchaseDetails() {
        var _transaction;

        var $ = window.$;

        var transaction = (_transaction = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_transaction, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Transaction"].ID, $('.orderid span').text()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_transaction, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Transaction"].REVENUE, extractPrice($('[data-elemname="total_text"]').text())), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_transaction, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Transaction"].TAX, extractPrice($('[data-elemname="tax_text"]').text())), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_transaction, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Transaction"].SHIPPING, extractPrice($('[data-elemname="shipping_text"]').text())), _transaction);

        var $productRows = $('.itemTable .row-fluid').not('.tableHead');
        var products = $productRows.map(function (_, row) {
            var _ref;

            var $row = $(row);
            return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Product"].ID, $row.find('[data-elemname^="sku_text"]').text()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Product"].NAME, $row.find('[data-elemname^="brand_part_text"]').text().trim()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Product"].PRICE, extractPrice($row.find('[data-elemname^="price_text"]').text())), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_1_progressive_web_sdk_dist_analytics_data_objects___["Product"].QUANTITY, extractQty($row.find('[data-elemname^="qty_text"]').text())), _ref;
        }).get();

        return {
            transaction: transaction,
            products: products
        };
    }
};

/* harmony default export */ __webpack_exports__["a"] = (checkoutConfirmation);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var header = {
    cartQty: function cartQty() {
        var total = window.$('.cart-toggle .icon-shopping-cart').text().trim();
        return parseInt(total);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (header);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html> <html> <head> <meta charset=UTF-8> <meta name=viewport content=\"width=device-width,initial-scale=1\"> </head> <body> <div class=wrapper> <div> <p class=\"ask-text bell\">Get notified on the latest Carparts.com deals, promotions and new products.</p> </div> <div class=js-button-container> <button id=js-deny class=\"ask-button deny\">No Thanks</button> <button id=js-allow class=\"ask-button allow\">Yes, Subscribe</button> </div> </div> </body> </html> ";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initMessaging = exports.handleNotificationClick = undefined;

var _extends2 = __webpack_require__(26);

var _extends3 = _interopRequireDefault(_extends2);

var _askFrame = __webpack_require__(133);

var _askFrame2 = _interopRequireDefault(_askFrame);

var _messaging = __webpack_require__(136);

var _messagingState = __webpack_require__(58);

var _logger = __webpack_require__(24);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var logger = void 0;

var DEFAULT_ASK_CONFIG = {
    showOnPageCount: 3,
    deferOnDismissal: 3
};

/**
 * Handles notification click events sent from the Messaging Client by directly
 * modifying window.location.href
 *
 * @param {object} event - The Event direct from the Messaging Client
 * @param {object) event.detail - Contains the `url` key from the message
 * @param {string} event.detail.url - The string that we should set href to
 */
var handleNotificationClick = exports.handleNotificationClick = function handleNotificationClick(event) {
    var url = event.detail && event.detail.url;

    if (typeof url === 'string' && url.length > 0) {
        window.location.href = url;
    }
};

var initMessaging = exports.initMessaging = function initMessaging(configuration) {
    // Initialize the logger and bind it to shouldAsk method
    logger = new _logger2.default('[Messaging UI]');
    (0, _messagingState.initStorage)();
    var boundShouldAsk = _messaging.shouldAsk.bind(undefined, logger);

    var defaultAskConfig = (0, _extends3.default)({}, DEFAULT_ASK_CONFIG, configuration.defaultAsk);

    return window.Progressive.MessagingClientInitPromise.then(function (state) {
        logger.log('Initializing...');

        // Register with the Messaging Client for notification click events that
        // occur while the visitor is viewing the website
        window.Mobify.WebPush.PWAClient.register(handleNotificationClick, window.Mobify.WebPush.PWAClient.Events.notificationClick);

        var _updateState = (0, _messagingState.updateState)(),
            pageCount = _updateState.pageCount,
            visitCountdowns = _updateState.visitCountdowns;

        // Add more values to state that we got from the Messaging Client, for
        // use with shouldAsk method


        var currentSubscriptionState = (0, _extends3.default)({}, state, {
            showOnPageCount: defaultAskConfig.showOnPageCount,
            isSubscribed: state.subscribed,
            pageCount: pageCount,
            visitCountdowns: visitCountdowns
        });

        var askFrame = new _askFrame2.default(defaultAskConfig);

        logger.log('Init complete');

        // If the developer wants us to automatically do everything, then we
        // will carry out the logic for displaying the ask ourselves
        if (defaultAskConfig.auto === true && boundShouldAsk(currentSubscriptionState)) {
            // Create the "ask" iframe
            askFrame.create();
            askFrame.setupListeners();
            askFrame.show();
        }

        return { askFrame: askFrame, currentSubscriptionState: currentSubscriptionState };
    });
};

/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylesheet_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_cart__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_header__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_checkout_confirmation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_progressive_web_sdk_dist_analytics_data_objects___ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_progressive_web_sdk_dist_analytics_data_objects____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_progressive_web_sdk_dist_analytics_data_objects___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__engagement_engine_analytics__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_progressive_web_sdk_dist_non_pwa_messaging__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_progressive_web_sdk_dist_non_pwa_messaging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_progressive_web_sdk_dist_non_pwa_messaging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__default_ask_html__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__default_ask_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__default_ask_html__);
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

/**
 * This file is the entry point for the `non-pwa.js` script which is loaded on
 * desktop environments by `/web/app/loader.js`.
 */

 // eslint-disable-line no-unused-vars








// Push Messaging



var wwwOrigin = window.location.origin.includes('staging') ? 'https://staging-pwa-carparts.usautoparts.com' : 'https://www.carparts.com';

var messagingConfiguration = {
    defaultAsk: {
        html: __WEBPACK_IMPORTED_MODULE_7__default_ask_html___default.a,
        auto: window.location.origin === wwwOrigin,
        showOnPageCount: 3,
        deferOnDismissal: 3
    }
};

var monitorUserActionsForCartAbandonment = function monitorUserActionsForCartAbandonment() {
    if (__WEBPACK_IMPORTED_MODULE_1__pages_cart__["a" /* default */].isActivePage()) {
        if (__WEBPACK_IMPORTED_MODULE_1__pages_cart__["a" /* default */].hasDeletedItem()) {
            // For example, the page url: /basket/?deleteitem=187493783&removeSku=
            // By this time, the remove-from-cart has just happened on desktop
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__engagement_engine_analytics__["a" /* sendCartEvent */])(__WEBPACK_IMPORTED_MODULE_4_progressive_web_sdk_dist_analytics_data_objects___["EVENT_ACTION"].removeFromCart, __WEBPACK_IMPORTED_MODULE_2__pages_header__["a" /* default */].cartQty());
        } else if (__WEBPACK_IMPORTED_MODULE_1__pages_cart__["a" /* default */].hasAddedItem()) {
            // Page url is /basket/?ai=true
            // By this time, the add-to-cart has just happened on desktop
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__engagement_engine_analytics__["a" /* sendCartEvent */])(__WEBPACK_IMPORTED_MODULE_4_progressive_web_sdk_dist_analytics_data_objects___["EVENT_ACTION"].addToCart, __WEBPACK_IMPORTED_MODULE_2__pages_header__["a" /* default */].cartQty());
        }
    } else if (__WEBPACK_IMPORTED_MODULE_3__pages_checkout_confirmation__["a" /* default */].isActivePage()) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__engagement_engine_analytics__["b" /* sendPurchaseEvent */])(__WEBPACK_IMPORTED_MODULE_3__pages_checkout_confirmation__["a" /* default */].getPurchaseDetails());
    }
};

/**
 * This is called after this script file has successfully loaded, and must exist
 * on `window.Mobify.NonPWA`. Include your own methods if needed.
 */
var init = function init() {
    // This initializes the Push Messaging feature, including the default ask
    // iframe which prompts visitors to subscribe.
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_progressive_web_sdk_dist_non_pwa_messaging__["initMessaging"])(messagingConfiguration);

    monitorUserActionsForCartAbandonment();
};

window.Mobify = window.Mobify || {};
window.Mobify.NonPWA = {
    init: init
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(80), __esModule: true };

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(81), __esModule: true };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(82), __esModule: true };

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(83), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(85), __esModule: true };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88), __esModule: true };

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(43);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(73);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(69);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55);
__webpack_require__(113);
module.exports = __webpack_require__(0).Array.from;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115);
module.exports = 0x1fffffffffffff;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
module.exports = __webpack_require__(0).Object.assign;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(119);
var $Object = __webpack_require__(0).Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
module.exports = __webpack_require__(0).Object.getPrototypeOf;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(121);
module.exports = __webpack_require__(0).Object.keys;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(122);
module.exports = __webpack_require__(0).Object.setPrototypeOf;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124);
__webpack_require__(123);
__webpack_require__(125);
__webpack_require__(126);
module.exports = __webpack_require__(0).Symbol;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55);
__webpack_require__(127);
module.exports = __webpack_require__(42).f('iterator');

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(5)
  , toLength  = __webpack_require__(54)
  , toIndex   = __webpack_require__(111);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(27)
  , TAG = __webpack_require__(1)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(4)
  , createDesc      = __webpack_require__(19);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(14)
  , gOPS    = __webpack_require__(34)
  , pIE     = __webpack_require__(22);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3).document && document.documentElement;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(18)
  , ITERATOR   = __webpack_require__(1)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(27);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(32)
  , descriptor     = __webpack_require__(19)
  , setToStringTag = __webpack_require__(36)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(1)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(1)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(14)
  , toIObject = __webpack_require__(5);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(23)('meta')
  , isObject = __webpack_require__(17)
  , has      = __webpack_require__(7)
  , setDesc  = __webpack_require__(4).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(12)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(14)
  , gOPS     = __webpack_require__(34)
  , pIE      = __webpack_require__(22)
  , toObject = __webpack_require__(20)
  , IObject  = __webpack_require__(48)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(4)
  , anObject = __webpack_require__(11)
  , getKeys  = __webpack_require__(14);

module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(5)
  , gOPN      = __webpack_require__(50).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17)
  , anObject = __webpack_require__(11);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(28)(Function.call, __webpack_require__(33).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39)
  , defined   = __webpack_require__(29);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(94)
  , ITERATOR  = __webpack_require__(1)('iterator')
  , Iterators = __webpack_require__(18);
module.exports = __webpack_require__(0).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(28)
  , $export        = __webpack_require__(2)
  , toObject       = __webpack_require__(20)
  , call           = __webpack_require__(100)
  , isArrayIter    = __webpack_require__(98)
  , toLength       = __webpack_require__(54)
  , createProperty = __webpack_require__(95)
  , getIterFn      = __webpack_require__(112);

$export($export.S + $export.F * !__webpack_require__(102)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(92)
  , step             = __webpack_require__(103)
  , Iterators        = __webpack_require__(18)
  , toIObject        = __webpack_require__(5);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(49)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(106)});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(32)});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperty: __webpack_require__(4).f});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(5)
  , $getOwnPropertyDescriptor = __webpack_require__(33).f;

__webpack_require__(35)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(20)
  , $getPrototypeOf = __webpack_require__(51);

__webpack_require__(35)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(20)
  , $keys    = __webpack_require__(14);

__webpack_require__(35)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(109).set});

/***/ }),
/* 123 */
/***/ (function(module, exports) {



/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(3)
  , has            = __webpack_require__(7)
  , DESCRIPTORS    = __webpack_require__(6)
  , $export        = __webpack_require__(2)
  , redefine       = __webpack_require__(53)
  , META           = __webpack_require__(105).KEY
  , $fails         = __webpack_require__(12)
  , shared         = __webpack_require__(38)
  , setToStringTag = __webpack_require__(36)
  , uid            = __webpack_require__(23)
  , wks            = __webpack_require__(1)
  , wksExt         = __webpack_require__(42)
  , wksDefine      = __webpack_require__(41)
  , keyOf          = __webpack_require__(104)
  , enumKeys       = __webpack_require__(96)
  , isArray        = __webpack_require__(99)
  , anObject       = __webpack_require__(11)
  , toIObject      = __webpack_require__(5)
  , toPrimitive    = __webpack_require__(40)
  , createDesc     = __webpack_require__(19)
  , _create        = __webpack_require__(32)
  , gOPNExt        = __webpack_require__(108)
  , $GOPD          = __webpack_require__(33)
  , $DP            = __webpack_require__(4)
  , $keys          = __webpack_require__(14)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(50).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(22).f  = $propertyIsEnumerable;
  __webpack_require__(34).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(31)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('asyncIterator');

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('observable');

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
var global        = __webpack_require__(3)
  , hide          = __webpack_require__(13)
  , Iterators     = __webpack_require__(18)
  , TO_STRING_TAG = __webpack_require__(1)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = __webpack_require__(21);

var _dataObject2 = _interopRequireDefault(_dataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function (_DataObject) {
    (0, _inherits3.default)(Page, _DataObject);
    (0, _createClass3.default)(Page, null, [{
        key: 'PATH',
        get: function get() {
            return 'path';
        } // Relative url to domain (ie. '/cart')

    }, {
        key: 'LOCATION',
        get: function get() {
            return 'location';
        } // Url with protocol, parameter, and hash (ie. 'https://www.example.com/cart?coupon=yay')

    }, {
        key: 'TITLE',
        get: function get() {
            return 'title';
        }
    }, {
        key: 'TEMPLATENAME',
        get: function get() {
            return 'templateName';
        } // Template name

    }, {
        key: 'STATUS',
        get: function get() {
            return 'status';
        } // set if from offline mode 'offline_success', 'offline_failed'

    }]);

    function Page(fields, additionalRequiredFields, keyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, Page);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call(this, [], [Page.PATH, Page.LOCATION, Page.TITLE, Page.TEMPLATENAME, Page.STATUS], fields, keepExtraFields));

        _this.isValid(additionalRequiredFields, keyMap);

        return _ret = _this.build(keyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return Page;
}(_dataObject2.default); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = Page;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = __webpack_require__(21);

var _dataObject2 = _interopRequireDefault(_dataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShoppingList = function (_DataObject) {
    (0, _inherits3.default)(ShoppingList, _DataObject);
    (0, _createClass3.default)(ShoppingList, null, [{
        key: 'TYPE',
        get: function get() {
            return 'type';
        } // e.g. cart/wishlist

    }, {
        key: 'COUNT',
        get: function get() {
            return 'count';
        }
        // The total of all cart line items before shipping and taxes.

    }, {
        key: 'SUBTOTAL',
        get: function get() {
            return 'subtotal';
        }
    }]);

    function ShoppingList(fields, additionalRequiredFields, keyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, ShoppingList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShoppingList.__proto__ || (0, _getPrototypeOf2.default)(ShoppingList)).call(this, [ShoppingList.COUNT, ShoppingList.TYPE], [ShoppingList.SUBTOTAL], fields, keepExtraFields));

        _this.isValid(additionalRequiredFields, keyMap);

        _this.sanitizeMoney(ShoppingList.SUBTOTAL);

        return _ret = _this.build(keyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return ShoppingList;
}(_dataObject2.default); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = ShoppingList;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(78);

var _get3 = _interopRequireDefault(_get2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = __webpack_require__(21);

var _dataObject2 = _interopRequireDefault(_dataObject);

var _product = __webpack_require__(56);

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var Transaction = function (_DataObject) {
    (0, _inherits3.default)(Transaction, _DataObject);
    (0, _createClass3.default)(Transaction, null, [{
        key: 'ID',
        get: function get() {
            return 'id';
        } // Transaction id

    }, {
        key: 'AFFILIATION',
        get: function get() {
            return 'affiliation';
        } // Checkout Method (Web, Paypal, Apple Pay, Google store ... etc)

    }, {
        key: 'REVENUE',
        get: function get() {
            return 'revenue';
        } // Grand total (including shipping and taxes)

    }, {
        key: 'TAX',
        get: function get() {
            return 'tax';
        }
    }, {
        key: 'SHIPPING',
        get: function get() {
            return 'shipping';
        }
    }, {
        key: 'LIST',
        get: function get() {
            return 'list';
        } // Purchase attribution - What affected this purchase? (ie. Web push)

    }, {
        key: 'STEP',
        get: function get() {
            return 'step';
        } // A number representing a step in the checkout process

    }, {
        key: 'OPTION',
        get: function get() {
            return 'option';
        } // Additional options

    }]);

    function Transaction(transactionInfo, productsInfo, additionalTransactionRequiredFields, additionalProductRequiredFields, transactionKeyMap, productKeyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
        (0, _classCallCheck3.default)(this, Transaction);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Transaction.__proto__ || (0, _getPrototypeOf2.default)(Transaction)).call(this, [Transaction.ID], [Transaction.AFFILIATION, Transaction.REVENUE, Transaction.TAX, Transaction.SHIPPING, Transaction.LIST, Transaction.STEP, Transaction.OPTION], transactionInfo, keepExtraFields));

        _this.isValid(additionalTransactionRequiredFields, transactionKeyMap);

        _this.sanitizeMoney(Transaction.REVENUE);
        _this.sanitizeMoney(Transaction.TAX);
        _this.sanitizeMoney(Transaction.SHIPPING);

        _this.products = [];
        productsInfo.forEach(function (product) {
            _this.products.push(new _product2.default(product, additionalProductRequiredFields, productKeyMap, keepExtraFields));
        });

        return _ret = _this.build(transactionKeyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Transaction, [{
        key: 'build',
        value: function build(keyMap) {
            return {
                transaction: (0, _get3.default)(Transaction.prototype.__proto__ || (0, _getPrototypeOf2.default)(Transaction.prototype), 'build', this).call(this, keyMap),
                products: this.products
            };
        }
    }]);
    return Transaction;
}(_dataObject2.default);

exports.default = Transaction;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = __webpack_require__(21);

var _dataObject2 = _interopRequireDefault(_dataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIInteraction = function (_DataObject) {
    (0, _inherits3.default)(UIInteraction, _DataObject);
    (0, _createClass3.default)(UIInteraction, null, [{
        key: 'SUBJECT',
        get: function get() {
            return 'subject';
        } // Ex. User

    }, {
        key: 'ACTION',
        get: function get() {
            return 'action';
        } // Ex. Open

    }, {
        key: 'OBJECT',
        get: function get() {
            return 'object';
        } // Ex. Modal

    }, {
        key: 'NAME',
        get: function get() {
            return 'name';
        }
    }, {
        key: 'CONTENT',
        get: function get() {
            return 'content';
        }
    }]);

    function UIInteraction(fields, additionalRequiredFields, keyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, UIInteraction);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UIInteraction.__proto__ || (0, _getPrototypeOf2.default)(UIInteraction)).call(this, [UIInteraction.SUBJECT, UIInteraction.OBJECT, UIInteraction.ACTION], [UIInteraction.NAME, UIInteraction.CONTENT], fields, keepExtraFields));

        _this.isValid(additionalRequiredFields, keyMap);

        return _ret = _this.build(keyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return UIInteraction;
}(_dataObject2.default); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = UIInteraction;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadAsset = exports.getAssetUrl = exports.initCacheManifest = exports.getBuildOrigin = exports.getScriptOrigin = exports.LOADER_SCRIPT_ID = exports.PREVIEW_SCRIPT_ID = undefined;

var _keys = __webpack_require__(44);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

// This is set on the preview loader script element by the
// preview script. See portal/templates/preview/preview.js
// in portal_all
var PREVIEW_SCRIPT_ID = exports.PREVIEW_SCRIPT_ID = 'mobify-preview-loader';

// the V8 tag sets this as the non-preview loader script id (see
// https://github.com/mobify/mobify-tag/blob/master/v8/v8.html)
var LOADER_SCRIPT_ID = exports.LOADER_SCRIPT_ID = 'mobify-v8-tag';

// Helper method to get the directory name of the given script element's src
// attribute. We expect only external script elements to be provided as argument
// and with an absolute src path
var getScriptOrigin = exports.getScriptOrigin = function getScriptOrigin(scriptEl) {
    var src = scriptEl && scriptEl.getAttribute('src');

    // This regular expression replaces the last found '/' and anything following
    // with a '/', i.e.:
    // 'http://www.mobify.com/hello-world.js' -> 'http://www.mobify.com/'
    var match = src && src.replace(/\/[^/]*$/, '/');

    if (!match) {
        console.error('Couldn\'t determine build file used. The mobify-tag may be placed incorrectly.'); // eslint-disable-line max-len
    }

    return match;
};

/**
 *  Grabs the location of the build so we can reference assets
 *  with absolute urls
 */
var getBuildOrigin = exports.getBuildOrigin = function getBuildOrigin() {
    // IMPORTANT! Don't use functions that require polyfills here
    // This function is used to load the polyfills so it will fail
    // if it contains ES6 functions,loader.js will error out and the
    // desktop site will be shown instead

    // Look for the loader.js script to get its origin. In production,
    // there will be one loader.js. In preview mode, there will be two,
    // and one will have its id set to PREVIEW_SCRIPT_ID. If we find
    // that preview loader, we use its origin. Otherwise we use the
    // origin of the production loader.js, looking it up using an id
    // that the tag sets.
    // For backwards compatibility, if we don't find a loader.js
    // that has a known id set, we will use the LAST loader.js/adaptive.min.js
    // script (loaded from a Mobify domain) that we find on the page.
    // This mimics the previous behaviour of this function.

    // Get all the scripts on the page...
    var scripts = Array.prototype.slice.call(document.getElementsByTagName('script'), 0)
    // ...eliminate any that have no src...
    .filter(function (script) {
        return script.src;
    })
    // ....in reverse order
    .reverse();

    var script =
    /*
     * Note: If you modify the script search criteria, please update the
     *       Error that is thrown immediately below when the search fails.
     */
    // Look for the mobify-preview-loader by id (set by the preview script)
    scripts.filter(function (script) {
        return script.id === PREVIEW_SCRIPT_ID;
    })[0] ||
    // Look for the main loader by id (set by the tag)
    scripts.filter(function (script) {
        return script.id === LOADER_SCRIPT_ID;
    })[0] ||
    // Look for a loader.js or adaptive.min.js loaded from a Mobify domain
    scripts.filter(function (script) {
        return (/mobify.+\/(loader|adaptive)(\.min)?\.js/.test(script.src)
        );
    })[0] ||
    // **Special transitional case** - For v7 tags loading preview bundles
    // that already support the v8 tag. In this case none of the loader.js
    // scripts will have an `id` and may not have come from *.mobify.*
    // origins (ie. when previewing on a device against a development bundle
    // served off of your machine: https://192.168.0.52:8443 for example).
    // In this case we'll just load the first loader/adaptive script we find
    // remembering that we've sorted the scripts in reverse order (which
    // should guarantee we get the preview <script> and not the production
    // one)
    scripts.filter(function (script) {
        return window.Mobify && window.Mobify.tagVersion && window.Mobify.tagVersion[0] === 7 && /\/(loader|adaptive)(\.min)?\.js/.test(script.src);
    })[0];

    if (script) {
        return getScriptOrigin(script);
    }

    // If we haven't found a candidate loader script at this point, we will
    // return a default build origin. This isn't optimal (we should probably
    // throw), but this is used in many places and so we'd need to thoroughly
    // test throwing before rolling it out.
    console.warn('getBuildOrigin() could not find a valid \'loader.js\' <script> ' + 'in the document! There must be at least one <script> element in this ' + 'document that match one of the following criteria (searched for in ' + 'this order):\n' + ('\t* \'id\' === \'' + PREVIEW_SCRIPT_ID + '\'\n') + ('\t* \'id\' === \'' + LOADER_SCRIPT_ID + '\'\n') + '\t* \'src\' contains \'mobify\' and either \'loader.js\' or \'adaptive.js\'\n' + '\t* the tag is a v7 tag and \'src\' contains \'loader.js\' or \'adaptive.js\'\n');
    console.warn('getBuildOrigin() using default origin: ' + script);

    return '//0.0.0.0:8443/';
};

// Expected to be overridden by initCacheManifest
var cacheHashManifest = {
    hashes: {},
    buildDate: Date.now()
};

/**
 * Expects object of the form shown above by cacheHashManifest
 * provided by scripts/create-hash-manifest.js run in a project
 */
var initCacheManifest = exports.initCacheManifest = function initCacheManifest(externalManifest) {
    cacheHashManifest = externalManifest;
};

/**
 *  Returns the full url for the provided asset path
 *  including a cache breaker.
 *  basePath and cacheBreaker arguments are optional
 */
var getAssetUrl = exports.getAssetUrl = function getAssetUrl(path, baseUrl, cacheBreaker) {
    if (cacheBreaker === undefined) {
        var hash = cacheHashManifest.hashes[path];

        cacheBreaker = hash || cacheHashManifest.buildDate;
    }

    return '' + (baseUrl || getBuildOrigin()) + path + '?' + cacheBreaker;
};

/**
 *  Dynamically adds an element to the page based on the nodeName
 *  and options supplied
 *
 *  ex: loadAsset('link', {
 *          href: 'css/stylesheet.css',
 *          rel: 'stylesheet',
 *          type: 'text/css'
 *      })
 */
var loadAsset = exports.loadAsset = function loadAsset(nodeName, options) {
    var firstScript = document.getElementsByTagName('script')[0];

    var script = document.createElement(nodeName);
    (0, _keys2.default)(options).forEach(function (prop) {
        script.setAttribute(prop, options[prop]);
    });
    firstScript.parentNode.insertBefore(script, firstScript);
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._clickHandler = exports._hideFrame = exports._showFrame = undefined;

var _extends2 = __webpack_require__(26);

var _extends3 = _interopRequireDefault(_extends2);

var _maxSafeInteger = __webpack_require__(70);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _logger = __webpack_require__(24);

var _logger2 = _interopRequireDefault(_logger);

var _assetUtils = __webpack_require__(132);

var _constants = __webpack_require__(134);

var _constants2 = _interopRequireDefault(_constants);

var _messagingState = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var _instance = void 0;

// Exported for testing
var _showFrame = exports._showFrame = function _showFrame(frame) {
    frame.style.transform = '';
};

// Exported for testing
var _hideFrame = exports._hideFrame = function _hideFrame(frame) {
    frame.style.transform = 'translateY(100%)';
};

// Exported for testing
var _clickHandler = exports._clickHandler = function _clickHandler(event) {
    var _this = this;

    var targetId = event.target.id;

    switch (targetId) {
        case _constants2.default.BUTTON_DENY_ID:
            {
                _hideFrame(this.frame);
                (0, _messagingState.startVisitCountdown)(this.config.deferOnDismissal, this.config.channelName);
                break;
            }

        case _constants2.default.BUTTON_ALLOW_ID:
            {
                _hideFrame(this.frame);
                window.Mobify.WebPush.PWAClient.subscribe().then(function (state) {
                    var message = void 0;

                    if (state.subscribed) {
                        message = 'Subscribed ' + (_this.config.channelName ? 'to channel ' + _this.config.channelName : /* istanbul ignore next */'');
                    } else if (!state.canSubscribe) {
                        message = 'Permissions blocked by user; can no longer subscribe.';
                    } else {
                        // The user dismissed the system-ask - back-off from asking again
                        (0, _messagingState.startVisitCountdown)(_this.config.deferOnDismissal, _this.config.channelName);
                        message = 'System ask was dismissed';
                    }

                    _this.logger.log('[Messaging UI]', message);

                    return state;
                });
                break;
            }
    }
};

var AskFrame = function AskFrame(configuration) {
    var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    if (_instance) {
        return _instance;
    }

    (0, _messagingState.initStorage)();

    this.config = configuration;
    this.doc = doc;
    this.logger = new _logger2.default('[Messaging UI]');

    _instance = this;

    return _instance;
};

AskFrame.prototype.show = function () {
    var _this2 = this;

    // Say that we showed a channel offer - it's okay for config.channel to be
    // undefined - Messaging Client will construe that as broadcast
    window.Mobify.WebPush.PWAClient.channelOfferShown();

    setTimeout(function () {
        _this2.logger.log('Showing ask dialog');
        _showFrame(_this2.frame);
    });

    return this;
};

AskFrame.prototype.setupListeners = function (clickHandler) {
    // Can provide clickHandler for testing purposes
    clickHandler = clickHandler || /* istanbul ignore next */_clickHandler.bind(this);

    var buttonContainer = this.frameDoc.getElementsByClassName(_constants2.default.BUTTON_CONTAINER_CLASS)[0];
    buttonContainer.addEventListener('click', clickHandler);

    return this;
};

AskFrame.prototype.create = function () {
    if (this.frame) {
        return this;
    }

    this.logger.log('Creating ask dialog...');

    this.frame = this.doc.createElement('iframe');
    var parentBody = this.doc.getElementsByTagName('body')[0];

    // Create the iframe
    this.frame.src = 'about:blank';
    this.frame.id = _constants2.default.ASK_IFRAME_ID;

    var styles = {
        position: 'fixed',
        left: '0px',
        bottom: '0px',
        zIndex: _maxSafeInteger2.default,
        width: '100%',
        height: '59px',
        border: 'none',
        transition: 'transform 0.3s ease-in-out',
        transform: 'translateY(100%)'
    };

    (0, _extends3.default)(this.frame.style, styles);

    parentBody.appendChild(this.frame);

    // HTML injection
    this.frameDoc = this.frame.contentWindow.document;
    this.frameDoc.getElementsByTagName('html')[0].innerHTML = this.config.html;

    // Stylesheet injection
    var iframeStyles = this.frameDoc.createElement('link');
    iframeStyles.rel = 'stylesheet';
    iframeStyles.type = 'text/css';
    iframeStyles.href = (0, _assetUtils.getAssetUrl)(_constants2.default.ASK_CSS);
    this.frameDoc.getElementsByTagName('head')[0].appendChild(iframeStyles);

    // User-defined script injection
    var iframeScript = this.frameDoc.createElement('script');
    iframeScript.type = 'text/javascript';
    iframeScript.src = (0, _assetUtils.getAssetUrl)(_constants2.default.ASK_SCRIPT);

    this.frameDoc.getElementsByTagName('body')[0].appendChild(iframeScript);

    this.logger.log('Ask dialog created');

    return this;
};

exports.default = AskFrame;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = {
    ASK_SCRIPT: 'non-pwa-ask.js',
    ASK_CSS: 'non-pwa-ask.css',
    BUTTON_CONTAINER_CLASS: 'js-button-container',
    BUTTON_DENY_ID: 'js-deny',
    BUTTON_ALLOW_ID: 'js-allow',
    ASK_IFRAME_ID: 'mobify-messaging-iframe'
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _storeEngine = __webpack_require__(138);

var _storeEngine2 = _interopRequireDefault(_storeEngine);

var _localStorage = __webpack_require__(139);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _memoryStorage = __webpack_require__(140);

var _memoryStorage2 = _interopRequireDefault(_memoryStorage);

var _expire = __webpack_require__(137);

var _expire2 = _interopRequireDefault(_expire);

var _logger = __webpack_require__(24);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Fallback for crazy environments like Safari Incognito
var logger = new _logger2.default('[Messaging UI]'); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

/**
 * Thin wrapper around store.js module that wraps local storage access
 *
 * @url https://github.com/marcuswestin/store.js/
 */


var _storageInstance = void 0;
/**
 * Create StoreJS instance with the provided optional namespace
 *
 * @param {string} [namespace] - prefix key name with provided string value
 */
var PushMessagingStore = function PushMessagingStore(namespace) {
    this.namespace = namespace ? namespace + '-' : '';

    this.store = _storageInstance || (_storageInstance = _storeEngine2.default.createStore([_localStorage2.default, _memoryStorage2.default], [_expire2.default]));

    logger.log('Storage wrapper created', this.namespace ? 'with namespace: ' + namespace : '');
    return this;
};

/**
 * Sets a key in local storage
 *
 * @param {string} key
 * @param {*} value
 * @param {number} [expiry] - expiration of key *in seconds* after current time
 * @returns {*} value
 */
PushMessagingStore.prototype.set = function (key, value, expiry) {
    key = '' + this.namespace + key;
    var expires = void 0;

    if (expiry) {
        expires = new Date().getTime() + expiry * 1000;
    }

    logger.log('Set ' + key + ' to:', value);
    return this.store.set(key, value, expires);
};

/**
 * Gets a get from local storage
 *
 * @param {string} key
 * @returns {*} the value of whatever is stored under `key`
 */
PushMessagingStore.prototype.get = function (key) {
    key = '' + this.namespace + key;
    var value = this.store.get(key);

    if (value) {
        logger.log('Got ' + key + ' with value:', value);
        return value;
    } else {
        return null;
    }
};

exports.default = PushMessagingStore;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMessagingSupported = exports.shouldAsk = exports.isSubscribedToChannel = undefined;

var _constants = __webpack_require__(57);

/**
 * Helper method to determine if visitor is subscribed to this channel name
 *
 * @param {boolean} isSubscribed - whether the visitor is currently subscribed to any channel
 * @param {array} channels - The list of channels the visitor is subscribed to
 * @param {string} [channelName] - The channel name for this ask instance; if
 *                                 undefined then assumes broadcast channel
 * @returns {boolean} - If the user is subscribed to the optional channel name
 */
var isSubscribedToChannel = exports.isSubscribedToChannel = function isSubscribedToChannel(isSubscribed, channels, channelName) {
    return isSubscribed && (channelName ? channels.includes(channelName) : true);
};

/**
 * Determines whether an ask should be shown, based on the following conditions:
 * 1. Messaging Client is ready and says the visitor is eligible for push notifications
      (i.e. has not revoked push notification permissions or has granted them already)
 * 2. The visitor is subscribed, but has not yet subscribed to this channel
 * 3. There is no visit countdown in progress for this channel (or it was disabled)
 * 4. Visitor has seen the required number of pages on the site (which may be disabled)
 *
 * @param {function} logger - Is bound to the correct logger; for testing
 * @param {object} props - Properties used to determine whether to ask
 * @returns {boolean} - true if "ask" can be shown, false otherwise
 */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var shouldAsk = exports.shouldAsk = function shouldAsk(logger, _ref, alreadyShown) {
    var showOnPageCount = _ref.showOnPageCount,
        channelName = _ref.channelName,
        isSubscribed = _ref.isSubscribed,
        canSubscribe = _ref.canSubscribe,
        channels = _ref.channels,
        pageCount = _ref.pageCount,
        visitCountdowns = _ref.visitCountdowns;

    // If `showOnPageCount` is false, then we disable page counts as a guard
    var modulus = showOnPageCount ? pageCount % showOnPageCount : 0;
    var visitCountdown = visitCountdowns[channelName || _constants.DEFAULT_CHANNEL];
    var message = false;

    if (!canSubscribe) {
        message = 'Unable to subscribe. Messaging Client is not ready or notification permissions are blocked';
    } else if (isSubscribedToChannel(isSubscribed, channels, channelName)) {
        message = 'Already subscribed';
    } else if (visitCountdown > 0) {
        message = 'Deferred until ' + visitCountdown + ' more visit(s)';
    } else if (modulus > 0) {
        if (!alreadyShown) {
            // This avoids "flip-flopping" when the UI is already shown and the
            // page count changes. i.e. once it's shown, ignore page count changes
            message = 'Waiting for ' + (showOnPageCount - modulus) + ' more page visit(s)';
        }
    }

    var channelMessage = channelName ? 'for channel ' + channelName : '';

    if (message !== false) {
        logger.log('Should not ask ' + channelMessage + ': ' + message);
        return false;
    }

    logger.log('Can ask', channelMessage);
    return true;
};

/**
 * Return true if and only if both the enabled and supported flags in
 * window.Progressive.Messaging are truthy. These flags are set by the
 * PWA loader, so they may be tested at any time after the PWA is loaded.
 * If this function is called before the loader runs, it will return
 * false.
 *
 * If this function returns false, then Messaging is not available at all,
 * and no UI for it need be (or should be) shown.
 * If this function returns true, then Messaging has been configured in the
 * PWA and the browser supports it, *but* the user may have blocked
 * notifications, or not be subscribed, or be running in a mode (such as
 * incognito) where subscriptions can't be created. Information on the
 * subscription status is provided when the Promise stored in
 * window.Progressive.MessagingClientInitPromise is resolved - see
 * the code in src/components/push-messaging-controller for details.
 */
var isMessagingSupported = exports.isMessagingSupported = function isMessagingSupported() {
    var progressive = window.Progressive || {};
    var messaging = progressive.Messaging || {};
    // Always return a boolean
    return Boolean(messaging.enabled && messaging.supported);
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

var namespace = 'expire_mixin'

module.exports = expirePlugin

function expirePlugin() {
	var expirations = this.namespace(namespace)
	
	return {
		set: expire_set,
		get: expire_get,
		remove: expire_remove
	}
	
	function expire_set(super_fn, key, val, expiration) {
		if (!this.hasNamespace(namespace)) {
			expirations.set(key, expiration)
		}
		return super_fn()
	}
	
	function expire_get(super_fn, key) {
		if (!this.hasNamespace(namespace)) {
			var expiration = expirations.get(key, Number.MAX_VALUE)
			if (expiration <= new Date().getTime()) {
				this.remove(key)
			}
		}
		return super_fn()
	}
	
	function expire_remove(super_fn, key) {
		if (!this.hasNamespace(namespace)) {
			expirations.remove(key)
		}
		return super_fn()
	}
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(59)
var slice = util.slice
var pluck = util.pluck
var each = util.each
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore,
}

var storeAPI = {
	version: '2.0.4',
	enabled: false,
	storage: null,

	// addStorage adds another storage to this store. The store
	// will use the first storage it receives that is enabled, so
	// call addStorage in the order of preferred storage.
	addStorage: function(storage) {
		if (this.enabled) { return }
		if (this._testStorage(storage)) {
			this._storage.resolved = storage
			this.enabled = true
			this.storage = storage.name
		}
	},

	// addPlugin will add a plugin to this store.
	addPlugin: function(plugin) {
		var self = this

		// If the plugin is an array, then add all plugins in the array.
		// This allows for a plugin to depend on other plugins.
		if (isList(plugin)) {
			each(plugin, function(plugin) {
				self.addPlugin(plugin)
			})
			return
		}

		// Keep track of all plugins we've seen so far, so that we
		// don't add any of them twice.
		var seenPlugin = pluck(this._seenPlugins, function(seenPlugin) { return (plugin === seenPlugin) })
		if (seenPlugin) {
			return
		}
		this._seenPlugins.push(plugin)

		// Check that the plugin is properly formed
		if (!isFunction(plugin)) {
			throw new Error('Plugins must be function values that return objects')
		}

		var pluginProperties = plugin.call(this)
		if (!isObject(pluginProperties)) {
			throw new Error('Plugins must return an object of function properties')
		}

		// Add the plugin function properties to this store instance.
		each(pluginProperties, function(pluginFnProp, propName) {
			if (!isFunction(pluginFnProp)) {
				throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
			}
			self._assignPluginFnProp(pluginFnProp, propName)
		})
	},

	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this._storage().read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this._storage().write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this._storage().remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this._storage().each(function(val, namespacedKey) {
			callback(self._deserialize(val), namespacedKey.replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this._storage().clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// namespace clones the current store and assigns it the given namespace
	namespace: function(namespace) {
		if (!this._legalNamespace.test(namespace)) {
			throw new Error('store.js namespaces can only have alhpanumerics + underscores and dashes')
		}
		// create a prefix that is very unlikely to collide with un-namespaced keys
		var namespacePrefix = '__storejs_'+namespace+'_'
		return create(this, {
			_namespacePrefix: namespacePrefix,
			_namespaceRegexp: namespacePrefix ? new RegExp('^'+namespacePrefix) : null
		})
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function(storages, plugins) {
		return createStore(storages, plugins)
	},
}

function createStore(storages, plugins) {
	var _privateStoreProps = {
		_seenPlugins: [],
		_namespacePrefix: '',
		_namespaceRegexp: null,
		_legalNamespace: /^[a-zA-Z0-9_\-]+$/, // alpha-numeric + underscore and dash

		_storage: function() {
			if (!this.enabled) {
				throw new Error("store.js: No supported storage has been added! "+
					"Add one (e.g store.addStorage(require('store/storages/cookieStorage')) "+
					"or use a build with more built-in storages (e.g "+
					"https://github.com/marcuswestin/store.js/tree/master/dist/store.legacy.min.js)")
			}
			return this._storage.resolved
		},

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
	}

	var store = create(_privateStoreProps, storeAPI)
	each(storages, function(storage) {
		store.addStorage(storage)
	})
	each(plugins, function(plugin) {
		store.addPlugin(plugin)
	})
	return store
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(59)
var Global = util.Global

module.exports = {
	name: 'localStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

function localStorage() {
	return Global.localStorage
}

function read(key) {
	return localStorage().getItem(key)
}

function write(key, data) {
	return localStorage().setItem(key, data)
}

function each(fn) {
	for (var i = localStorage().length - 1; i >= 0; i--) {
		var key = localStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return localStorage().removeItem(key)
}

function clearAll() {
	return localStorage().clear()
}


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.

module.exports = {
	name: 'memoryStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var memoryStorage = {}

function read(key) {
	return memoryStorage[key]
}

function write(key, data) {
	memoryStorage[key] = data
}

function each(callback) {
	for (var key in memoryStorage) {
		if (memoryStorage.hasOwnProperty(key)) {
			callback(memoryStorage[key], key)
		}
	}
}

function remove(key) {
	delete memoryStorage[key]
}

function clearAll(key) {
	memoryStorage = {}
}


/***/ }),
/* 141 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// non-pwa.js